export enum PricingModel {
  STANDARD = "standard",
  PACKAGE = "package",
  GRADUATED = "graduated",
  VOLUME = "volume",
}

export enum PricingMeasurementUnit {
  QUANTITY = "quantity",
  WEIGHT = "weight",
  VOLUME = "volume",
}
